// extracted by mini-css-extract-plugin
export var chevron = "_1i-d";
export var disabled = "_1i-b";
export var error = "_1i-c";
export var hideBorder = "_1i-1";
export var icon = "_1i-e";
export var input = "_1i-0";
export var large = "_1i-f";
export var open = "_1i-9";
export var placeholder = "_1i-a";
export var regular = "_1i-5";
export var singleRowInput = "_1i-2";
export var singleSelectInput = "_1i-3 _1i-0";
export var small = "_1i-4";
export var spinnerContainer = "_1i-i";
export var tag = "_1i-7";
export var tagsContainer = "_1i-8";
export var tagsInput = "_1i-6 _1i-0";
export var xSmall = "_1i-g";
export var xxSmall = "_1i-h";